const FileIcon = () => {
  return (
    <svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.33341 16.9999V13.6666H20.6667V16.9999H7.33341ZM7.33341 10.3333V6.99992H20.6667V10.3333H7.33341ZM4.00008 20.3333H16.5001C17.3056 20.3333 18.0556 20.5069 18.7501 20.8541C19.4445 21.2013 20.0279 21.6944 20.5001 22.3333L24.0001 26.9166V3.66659H4.00008V20.3333ZM4.00008 30.3333H22.4167L17.8751 24.3749C17.7084 24.1527 17.507 23.9791 17.2709 23.8541C17.0348 23.7291 16.7779 23.6666 16.5001 23.6666H4.00008V30.3333ZM24.0001 33.6666H4.00008C3.08341 33.6666 2.29869 33.3402 1.64591 32.6874C0.993137 32.0346 0.666748 31.2499 0.666748 30.3333V3.66659C0.666748 2.74992 0.993137 1.9652 1.64591 1.31242C2.29869 0.659641 3.08341 0.333252 4.00008 0.333252H24.0001C24.9167 0.333252 25.7015 0.659641 26.3542 1.31242C27.007 1.9652 27.3334 2.74992 27.3334 3.66659V30.3333C27.3334 31.2499 27.007 32.0346 26.3542 32.6874C25.7015 33.3402 24.9167 33.6666 24.0001 33.6666Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default FileIcon;
